"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEAD_TYPES = void 0;
exports.HEAD_TYPES = {
    STYLE: "style",
    LINK: "link",
    META: "meta",
    TITLE: "title",
};
